import { createAsyncThunk } from '@reduxjs/toolkit';
import { getItems } from '@api/items';
import { setQuery } from '@data/slices/itemSlice';

export const fetchItemsThunk = createAsyncThunk(
  'items/fetchItems',
  async (searchTerm: string, thunkAPI) => {
    const dispatch = thunkAPI.dispatch;

    const searchQuery = new URLSearchParams({
      search_term: searchTerm.replace(/\s/g, ''),
    });

    if (!searchTerm) {
      searchQuery.delete('search_term');
    }

    dispatch(setQuery(searchTerm));

    const response = await getItems(searchQuery);
    return response;
  }
);
